<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-4">
        <div class="card"><div class="card-body">
          <h5 class="mb-3">Templates</h5>
          <ul class="list-group">
            <li v-for="t in templates" :key="t.id" class="list-group-item" :class="{ active: current && current.id === t.id }" role="button" @click="select(t)">
              {{ t.name || ('Tipo ' + t.type_email) }}
            </li>
          </ul>
        </div></div>
      </div>
      <div class="col-md-8">
        <div class="card" v-if="current"><div class="card-body">
          <h5 class="mb-3">{{ current.name }}</h5>
          <div class="row">
            <div class="form-group col-sm-6"><label>Remetente (nome)</label><input type="text" class="form-control" v-model="current.from_name"></div>
            <div class="form-group col-sm-6"><label>Remetente (e-mail)</label><input type="email" class="form-control" v-model="current.from_email"></div>
          </div>
          <div class="form-group"><label>Assunto *</label><input type="text" class="form-control" v-model="current.subject"></div>
          <div class="form-group">
            <label>Conteúdo (HTML)</label>
            <textarea class="form-control" rows="10" v-model="current.content"></textarea>
            <small class="text-muted">Variáveis: <code>{$nome}</code>, <code>{$email}</code><span v-if="current.type_email === 2">, <code>{$token}</code></span></small>
          </div>
        </div>
        <div class="card-footer text-right">
          <button class="btn btn-primary" :disabled="saving" @click="save()">Salvar template</button>
        </div>
        </div>
        <div v-else class="text-muted">Selecione um template.</div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/page-header'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'

export default {
  components: { PageHeader },
  name: 'app-email-templates',
  data () {
    return { title: 'E-mails do App', items: [{ text: 'App' }, { text: 'E-mails', active: true }], templates: [], current: null, saving: false }
  },
  mounted () {
    const loader = this.$loading.show()
    services.listEmailTemplates().then(r => { this.templates = r.data.data; if (this.templates.length) this.select(this.templates[0]) }).catch(() => errorMessage('Falha ao carregar.', 3000)).finally(() => loader.hide())
  },
  methods: {
    select (t) { this.current = { ...t } },
    async save () {
      this.saving = true
      try {
        await services.updateEmailTemplate(this.current.id, {
          name: this.current.name,
          from_name: this.current.from_name,
          from_email: this.current.from_email,
          subject: this.current.subject,
          content: this.current.content
        })
        successMessage('Template salvo.', 2000)
      } catch (e) { errorMessage('Falha ao salvar.', 3000) } finally { this.saving = false }
    }
  }
}
</script>
